<template>
  <div class="w-full px-3 py-2 flex" :class="classes">
    <Avatar class="mr-3" :size="36" :src="notification.owner.avatarUrl" />
    <div
      class="font-secondary text-[14px] leading-5 tablet-h:leading-[19px] tablet-h:text-[13px] text-gray-800 -mt-1 flex flex-col justify-between"
    >
      <div class="mb-1 tablet-h:mb-0.5">{{ copy }}</div>
      <div class="text-[13px] tablet-h:text-[12px] opacity-50">
        {{ formatDistanceToNowStrict(props.notification.timestamp) }} ago
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  NotificationType,
  type Notification,
} from '@/shared/graphql/legacy/generated'
import { Avatar } from '@dacr/ui'
import { formatDistanceToNowStrict } from 'date-fns'
import { computed } from 'vue'

const props = defineProps<{
  notification: Notification
}>()

const classes = computed(() => ({
  'tablet-h:hover:bg-[#FAFAFA]': props.notification.read,
  'bg-green-900/10': !props.notification.read,
}))

const copy = computed(() => {
  if (props.notification.type === NotificationType.UserVerificationSucess) {
    return 'Your identity has been verified.'
  }

  return "We couldn't verify your identity. Please try again."
})
</script>
